import type { EditorLocale } from './types.js';

export const en: EditorLocale = {
  toolbar: {
    undo: 'Undo (Ctrl+Z)',
    redo: 'Redo (Ctrl+Y)',
    textFormat: 'Text Format',
    paragraph: 'Paragraph',
    heading: (level) => `Heading ${level}`,
    quote: 'Quote',
    codeBlock: 'Code Block',
    bold: 'Bold (Ctrl+B)',
    italic: 'Italic (Ctrl+I)',
    underline: 'Underline (Ctrl+U)',
    inlineCode: 'Inline Code (Ctrl+`)',
    alignLeft: 'Align Left',
    alignCenter: 'Align Center',
    alignRight: 'Align Right',
    justify: 'Justify',
    bulletList: 'Bullet List',
    orderedList: 'Ordered List',
    insertLink: 'Insert Link',
    insertImage: 'Insert Image',
    blockquote: 'Blockquote',
    horizontalRule: 'Horizontal Rule',
    htmlSource: 'Toggle HTML Source',
    calloutInfo: 'Callout: Info',
    calloutSuccess: 'Callout: Success',
    calloutWarning: 'Callout: Warning',
    calloutDanger: 'Callout: Danger',
    insertCallout: 'Insert Callout',
  },
  statusBar: {
    words: 'Words',
    characters: 'Characters',
    htmlSource: 'HTML',
  },
  dialogs: {
    linkUrl: 'Link URL:',
    openInNewTab: 'Open in new tab?',
    imageUrl: 'Image URL:',
    imageAlt: 'Alt text (optional):',
  },
  plugins: {
    ai: {
      panelTitle: 'AI Assistant',
      noSelection: '(No text selected — entire document will be used)',
      customPromptPlaceholder: 'Enter custom instruction…',
      runButton: 'Run',
      applyButton: 'Apply',
      generating: '⏳ Generating…',
      noApiKey: '⚠️ No API key configured. Pass apiKey or endpoint when creating the plugin.',
      errorPrefix: '❌ Error: ',
      actions: {
        improve: 'Improve',
        shorten: 'Shorten',
        expand: 'Expand',
        summarize: 'Summarize',
        toGerman: '🇩🇪 To German',
        toEnglish: '🇬🇧 To English',
      },
    },
    emoji: {
      buttonTitle: 'Insert emoji',
      categories: {
        faces: 'Faces',
        hearts: 'Hearts',
        gestures: 'Gestures',
        nature: 'Nature',
        food: 'Food',
        objects: 'Objects',
        symbols: 'Symbols',
      },
    },
  },
};
